/* Le Matin — smooth accordion for Candles & Toppers */
(function () {
  function init(details) {
    if (!details || details.dataset.candlesToppersReady) return;
    details.dataset.candlesToppersReady = '1';

    const content = details.querySelector('.accordion__content');
    const summary = details.querySelector('summary');
    if (!content || !summary) return;

    const DURATION = 500;
    const ACCORDION_EVENT = 'lematin:accordion-open';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let animating = false;

    const clear = () => {
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
      content.style.opacity = '';
      content.style.paddingTop = '';
      content.style.paddingBottom = '';
      animating = false;
    };

    /* Vertical padding has to be animated alongside the height. With
       box-sizing:border-box a `height:0` element still renders at least as tall
       as its padding, so leaving the padding in place makes the separator snap by
       the padding amount at the very start/end of the animation. */
    const readPadding = () => {
      const cs = getComputedStyle(content);
      return { top: cs.paddingTop, bottom: cs.paddingBottom };
    };

    const transition = () =>
      'height ' + DURATION + 'ms ease-in-out, ' +
      'padding-top ' + DURATION + 'ms ease-in-out, ' +
      'padding-bottom ' + DURATION + 'ms ease-in-out, ' +
      'opacity ' + DURATION + 'ms ease-in-out';

    /* Broadcast so the other product-page accordions collapse — only one open
       at a time. */
    const announceOpen = () => {
      document.dispatchEvent(new CustomEvent(ACCORDION_EVENT, { detail: { source: details } }));
    };

    const expand = () => {
      announceOpen();
      animating = true;
      details.open = true;
      const pad = readPadding();
      const target = content.scrollHeight;
      content.style.overflow = 'hidden';
      content.style.height = '0px';
      content.style.paddingTop = '0px';
      content.style.paddingBottom = '0px';
      content.style.opacity = '0';
      requestAnimationFrame(() => {
        content.style.transition = transition();
        content.style.height = target + 'px';
        content.style.paddingTop = pad.top;
        content.style.paddingBottom = pad.bottom;
        content.style.opacity = '1';
      });
      const done = (e) => {
        if (e.propertyName !== 'height') return;
        content.removeEventListener('transitionend', done);
        clear();
      };
      content.addEventListener('transitionend', done);
    };

    const collapse = () => {
      animating = true;
      content.style.overflow = 'hidden';
      content.style.height = content.scrollHeight + 'px';
      content.style.opacity = '1';
      requestAnimationFrame(() => {
        content.style.transition = transition();
        content.style.height = '0px';
        content.style.paddingTop = '0px';
        content.style.paddingBottom = '0px';
        content.style.opacity = '0';
      });
      const done = (e) => {
        if (e.propertyName !== 'height') return;
        content.removeEventListener('transitionend', done);
        details.open = false;
        clear();
      };
      content.addEventListener('transitionend', done);
    };

    summary.addEventListener('click', (e) => {
      if (reduceMotion) {
        if (!details.open) announceOpen();
        return;
      }
      e.preventDefault();
      if (animating) return;
      if (details.open) collapse();
      else expand();
    });

    document.addEventListener(ACCORDION_EVENT, (e) => {
      if (e.detail.source === details || !details.open) return;
      if (reduceMotion) { details.open = false; return; }
      if (animating) return;
      collapse();
    });
  }

  function boot() {
    document.querySelectorAll('.candles-toppers details').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
